import { types } from 'mobx-state-tree';

const ConcernColor = types.model('ConcernColor', {
  id: types.identifierNumber,
  color: types.string,
  orderRank: types.number,
});

export default ConcernColor;
